// extracted by mini-css-extract-plugin
export default {"container":"MachineCard_container__a5ucx"};